import { render, staticRenderFns } from "./loteresultados.vue?vue&type=template&id=2d62c853&"
import script from "./loteresultados.vue?vue&type=script&lang=js&"
export * from "./loteresultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports